import React, { Component } from "react";
import { StudioSectionHeader, StudioFoldControl } from "./InstagramUnifiedStudioParts";
import http from "../modules/api";
import AiImageStudioWorkflowClass from "../modules/common/AiImageStudioWorkflowClass";
import TitleContentDialogV2 from "../modules/dialogs/TitleContentDialogV2";
import SaveDialogV2 from "../modules/dialogs/SaveDialogV2";

const INSTAGRAM_CREATE_POST_URL = "/shop/instagram/InstagramCreatePost";
const INSTAGRAM_CREATE_AI_IMAGE_AUTOMATION_URL = "/shop/instagram/InstagramCreateAiImageAutomation";
const AI_STUDIO_GALLERY_STEP_LIST_URL = "/rest/shop/aiStudio/galleryStepList";
const AI_STUDIO_GALLERY_STEP_HIDE_URL = "/rest/shop/aiStudio/galleryStep/hide";
const AI_STUDIO_APPLY_IMAGE_STORAGE_KEY = "instagram_ai_studio_apply_image";
const AI_STUDIO_APPLY_AUTOMATION_RULE_STORAGE_KEY = "instagram_ai_studio_apply_automation_rule";
const AI_STUDIO_HISTORY_PAGE_SIZE = 24;
const RECOMMEND_VISIBLE_COUNT_STEP = 6;

const AI_STUDIO_IMAGE_TEMPLATE_LIST_URL = "/rest/shop/aiStudio/imageTemplate/list";

class InstagramAiStudioList extends Component {
  constructor(props) {
    super(props);
    this.aiStudioHistoryLoading = false;
    this.pendingStudioHistoryReset = false;
    this.scrollTimer = null;

    this.state = {
      recommendImages: [],
      recommendImagesLoading: false,
      visibleRecommendCount: RECOMMEND_VISIBLE_COUNT_STEP,
      recommendExpanded: false,
      galleryExpanded: false,
      studioImageList: [],
      totalCnt: 0,
      studioImageListLoading: false,
      hasMoreStudioImageList: true,
      show_robo_img_popup: false,
      ai_studio_initial_prompt: "",
      ai_studio_initial_sample_prompt: "",
      ai_studio_initial_sample_mode: false,
      ai_studio_initial_sample_title: "",
      ai_studio_initial_sample_template_cd: "",
      ai_studio_initial_sample_ai_image_template_seq: "",
      ai_studio_initial_sample_reference_image_url: "",
      ai_studio_initial_sample_reference_image_use_yn: "N",
      ai_studio_initial_sample_scene_description: "",
      ai_studio_initial_sample_result_example_url: "",
      ai_studio_initial_image_url: "",
      ai_studio_initial_source_image_url: "",
      ai_studio_initial_history_seq: "",
      ai_studio_initial_step_no: "",
      ai_studio_initial_history_step_seq: "",
      ai_studio_initial_result_seq: "",
      ai_studio_initial_result_no: "",
      ai_studio_initial_result_image_url: "",
      ai_studio_initial_ratio: "",
      ai_studio_initial_ratio_cd: "",
      ai_studio_initial_style_type_cd: "",
      ai_studio_initial_composition_type_cd: "",
      deleteDialogOpen: false,
      deleteTarget: null,
      deleteProcessing: false,
      hiddenStudioImageStepSeqs: new Set(),

      save_dialog_show_state: false,
      save_dialog_content: "로딩중 입니다.",
      save_dialog_button_list: [{ title: "확인", type: "1", display_yn: "N" }],
    };

    this.loadRecommendImages = this.loadRecommendImages.bind(this);
    this.handleLoadMoreRecommend = this.handleLoadMoreRecommend.bind(this);
    this.loadStudioHistory = this.loadStudioHistory.bind(this);
    this.handleWindowScroll = this.handleWindowScroll.bind(this);
    this.checkNeedLoadMore = this.checkNeedLoadMore.bind(this);
    this.handleCreateImage = this.handleCreateImage.bind(this);
    this.handleUseRecommendImage = this.handleUseRecommendImage.bind(this);
    this.handleOpenStudioHistoryStep = this.handleOpenStudioHistoryStep.bind(this);
    this.handleRefreshStudioImageList = this.handleRefreshStudioImageList.bind(this);
    this.handleInstagramRegister = this.handleInstagramRegister.bind(this);
    this.handleDownloadImage = this.handleDownloadImage.bind(this);
    this.handleDeleteStudioImage = this.handleDeleteStudioImage.bind(this);
    this.closeDeleteDialog = this.closeDeleteDialog.bind(this);
    this.confirmDeleteStudioImage = this.confirmDeleteStudioImage.bind(this);
  }

  componentDidMount() {
    this.loadRecommendImages();

    const searchParams = new URLSearchParams(window.location.search);
    const openAiStudioForTutorial = searchParams.get("open_ai_studio") === "Y";

    if (openAiStudioForTutorial) {
      // 일반적인 "새 이미지 만들기"와 동일한 흐름을 사용합니다.
      // 이용기간이 종료된 경우에는 기존 checkInstagramFreePeriod() 정책대로 팝업이 열리지 않습니다.
      this.handleCreateImage();

      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.delete("open_ai_studio");
      window.history.replaceState({}, document.title, `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`);
    }

    if (this.getAiStudioHistoryUrl()) {
      this.loadStudioHistory(true);
      window.addEventListener("scroll", this.handleWindowScroll);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleWindowScroll);

    if (this.scrollTimer) {
      clearTimeout(this.scrollTimer);
      this.scrollTimer = null;
    }
  }

  getAiStudioHistoryUrl() {
    return this.props.aiStudioHistoryUrl || AI_STUDIO_GALLERY_STEP_LIST_URL;
  }

  handleWindowScroll() {
    if (this.scrollTimer) {
      clearTimeout(this.scrollTimer);
    }

    this.scrollTimer = setTimeout(this.checkNeedLoadMore, 120);
  }

  checkNeedLoadMore() {
    if ((this.props.embedded && (!this.props.active || !this.state.galleryExpanded)) || !this.getAiStudioHistoryUrl() || this.aiStudioHistoryLoading || !this.state.hasMoreStudioImageList) {
      return;
    }

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    const documentHeight = Math.max(
      document.body.scrollHeight,
      document.documentElement.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.offsetHeight,
      document.body.clientHeight,
      document.documentElement.clientHeight
    );

    if (scrollTop + viewportHeight >= documentHeight - (viewportHeight * 1.5)) {
      this.loadStudioHistory(false);
    }
  }

  mergeImageList(prevList, nextList) {
    const mergedList = [];
    const existsMap = {};

    (prevList || []).concat(nextList || []).forEach((item, index) => {
      const key = this.getStudioImageKey(item, index);

      if (existsMap[key]) {
        return;
      }

      existsMap[key] = true;
      mergedList.push(item);
    });

    return mergedList;
  }

  getStudioImageKey(item, index) {
    if (!item) {
      return "empty_" + index;
    }

    if (item.ai_studio_history_step_seq) {
      return "step_seq_" + item.ai_studio_history_step_seq;
    }

    if (item.ai_studio_history_seq && item.step_no) {
      return "history_step_" + item.ai_studio_history_seq + "_" + item.step_no;
    }

    return String(
      item.seq
      || item.img_seq
      || item.image_seq
      || item.source_url
      || item.output_image_url
      || item.preview_image_url
      || item.generated_thumbnail_url
      || item.generated_image_url
      || index
    );
  }

  getListFromResponseData(data) {
    if (!data) {
      return [];
    }

    if (Array.isArray(data.list)) {
      return data.list;
    }

    if (Array.isArray(data.history_list)) {
      return data.history_list;
    }

    if (Array.isArray(data.step_list)) {
      return data.step_list;
    }

    if (Array.isArray(data.rows)) {
      return data.rows;
    }

    if (Array.isArray(data.data)) {
      return data.data;
    }

    return [];
  }

  getTotalCntFromResponseData(data, listLength) {
    if (!data) {
      return 0;
    }

    const totalCnt = data.totalCnt
      || data.total_cnt
      || data.total_count
      || data.count
      || 0;

    const parsedTotalCnt = Number(totalCnt);

    if (!isNaN(parsedTotalCnt) && parsedTotalCnt > 0) {
      return parsedTotalCnt;
    }

    return listLength || 0;
  }

  loadStudioHistory(reset) {
    const aiStudioHistoryUrl = this.getAiStudioHistoryUrl();

    if (!aiStudioHistoryUrl) {
      return;
    }

    if (this.aiStudioHistoryLoading) {
      if (reset) {
        this.pendingStudioHistoryReset = true;
      }
      return;
    }

    if (!reset && !this.state.hasMoreStudioImageList) {
      return;
    }

    const rowcnt = this.props.aiStudioHistoryRowCnt || AI_STUDIO_HISTORY_PAGE_SIZE;
    const startidx = reset ? 0 : this.state.studioImageList.length;

    this.aiStudioHistoryLoading = true;
    this.setState({ studioImageListLoading: true });

    http.get(aiStudioHistoryUrl, {
      params: {
        startidx: startidx,
        rowcnt: rowcnt,
        start: startidx,
        row_cnt: rowcnt,
        auto_yn: this.props.auto_yn || "",
      }
    })
      .then((res) => {
        const data = res && res.data ? res.data : {};
        const list = this.getListFromResponseData(data);
        const nextStudioImageList = reset ? list : this.mergeImageList(this.state.studioImageList, list);
        const totalCnt = this.getTotalCntFromResponseData(data, nextStudioImageList.length);
        const addedCnt = reset ? nextStudioImageList.length : nextStudioImageList.length - this.state.studioImageList.length;
        const hasExplicitTotalCnt = Number(data.totalCnt || data.total_cnt || data.total_count || data.count || 0) > 0;
        const hasMoreStudioImageList = list.length > 0 && addedCnt > 0 && (
          hasExplicitTotalCnt
            ? nextStudioImageList.length < totalCnt
            : list.length >= rowcnt
        );

        this.aiStudioHistoryLoading = false;

        this.setState({
          studioImageList: nextStudioImageList,
          totalCnt: totalCnt || nextStudioImageList.length,
          studioImageListLoading: false,
          hasMoreStudioImageList: hasMoreStudioImageList,
        }, () => {
          if (this.pendingStudioHistoryReset) {
            this.pendingStudioHistoryReset = false;
            this.loadStudioHistory(true);
          }
        });
      })
      .catch((e) => {
        console.error("AI 스튜디오 이미지 목록 호출 실패:", e);
        this.aiStudioHistoryLoading = false;
        this.setState({
          studioImageList: reset ? [] : this.state.studioImageList,
          totalCnt: reset ? 0 : this.state.totalCnt,
          studioImageListLoading: false,
          hasMoreStudioImageList: false,
        }, () => {
          if (this.pendingStudioHistoryReset) {
            this.pendingStudioHistoryReset = false;
            this.loadStudioHistory(true);
          }
        });
      });
  }

  handleRefreshStudioImageList() {
    if (this.getAiStudioHistoryUrl()) {
      this.loadStudioHistory(true);
    }
  }

  async checkInstagramFreePeriod() {
    try {
      const res = await http.get("/rest/shop/instagram/FreePreriod");
      const isFinish = res && res.data ? Number(res.data.is_finish) : null;

      if (isFinish === 1) {
        window.alert("이용 기간이 종료되었습니다.");
        return false;
      }

      return true;
    } catch (error) {
      console.error("인스타그램 이용 기간 확인 실패:", error);
      return true;
    }
  }

  async handleCreateImage(e) {
    if (e) {
      e.stopPropagation();
    }

    if (!(await this.checkInstagramFreePeriod())) {
      return;
    }

    this.setState({
      show_robo_img_popup: true,
      ai_studio_initial_prompt: "",
      ai_studio_initial_sample_prompt: "",
      ai_studio_initial_sample_mode: false,
      ai_studio_initial_sample_title: "",
      ai_studio_initial_sample_template_cd: "",
      ai_studio_initial_sample_ai_image_template_seq: "",
      ai_studio_initial_sample_reference_image_url: "",
      ai_studio_initial_sample_reference_image_use_yn: "N",
      ai_studio_initial_sample_scene_description: "",
      ai_studio_initial_sample_result_example_url: "",
      ai_studio_initial_image_url: "",
      ai_studio_initial_source_image_url: "",
      ai_studio_initial_history_seq: "",
      ai_studio_initial_step_no: "",
      ai_studio_initial_history_step_seq: "",
      ai_studio_initial_result_seq: "",
      ai_studio_initial_result_no: "",
      ai_studio_initial_result_image_url: "",
      ai_studio_initial_ratio: "",
      ai_studio_initial_ratio_cd: "",
      ai_studio_initial_style_type_cd: "",
      ai_studio_initial_composition_type_cd: "",
    });
  }

  async handleUseRecommendImage(item, e) {
    if (e) {
      e.stopPropagation();
    }

    if (!(await this.checkInstagramFreePeriod())) {
      return;
    }

    this.setState({
      show_robo_img_popup: true,
      ai_studio_initial_prompt: "",
      ai_studio_initial_sample_prompt: item.prompt || "",
      ai_studio_initial_sample_prompt_placeholder: item.prompt_placeholder || "",
      ai_studio_initial_sample_mode: true,
      ai_studio_initial_sample_title: item.title || "",
      ai_studio_initial_sample_template_cd: item.template_cd || "",
      ai_studio_initial_sample_ai_image_template_seq: item.ai_image_template_seq || item.seq || "",
      ai_studio_initial_sample_reference_image_url: item.reference_image_url || "",
      ai_studio_initial_sample_reference_image_use_yn: item.reference_image_use_yn === "Y" ? "Y" : "N",
      ai_studio_initial_sample_scene_description: item.scene_description || "",
      ai_studio_initial_sample_result_example_url: this.getImageUrl(item),
      ai_studio_initial_image_url: item.input_src || item.inputImageUrl || "",
      ai_studio_initial_source_image_url: "",
      ai_studio_initial_history_seq: "",
      ai_studio_initial_step_no: "",
      ai_studio_initial_history_step_seq: "",
      ai_studio_initial_result_seq: "",
      ai_studio_initial_result_no: "",
      ai_studio_initial_result_image_url: "",
      ai_studio_initial_ratio: "",
      ai_studio_initial_ratio_cd: "",
      ai_studio_initial_style_type_cd: "",
      ai_studio_initial_composition_type_cd: "",
    });
  }

  async handleOpenStudioHistoryStep(item, e) {
    if (e) {
      e.stopPropagation();
    }

    if (!(await this.checkInstagramFreePeriod())) {
      return;
    }

    const aiStudioHistorySeq = item.ai_studio_history_seq || item.aiStudioHistorySeq || "";
    const stepNo = item.step_no || item.stepNo || "";
    const aiStudioHistoryStepSeq = item.ai_studio_history_step_seq || item.aiStudioHistoryStepSeq || "";
    const aiStudioHistoryStepResultSeq = item.ai_studio_history_step_result_seq || item.aiStudioHistoryStepResultSeq || "";
    const resultNo = item.result_no || item.resultNo || "";
    const imageUrl = this.getImageUrl(item);
    const imageRatio = item.image_ratio || item.imageRatio || item.ratio || "";
    const ratioCd = item.ratio_cd || item.ratioCd || "";
    const styleTypeCd = item.style_type_cd || item.styleTypeCd || "";
    const compositionTypeCd = item.camera_angle_cd || item.cameraAngleCd || item.composition_type_cd || item.compositionTypeCd || "";
    const promptText = item.prompt_text || item.promptText || item.prompt || "";
    const sourceImageUrl = item.source_image_url || item.sourceImageUrl || "";

    if (!aiStudioHistorySeq || !stepNo || !aiStudioHistoryStepSeq) {
      window.alert("AI 스튜디오 히스토리 정보를 찾을 수 없습니다.");
      return;
    }

    this.setState({
      show_robo_img_popup: true,
      ai_studio_initial_prompt: promptText,
      ai_studio_initial_sample_prompt: "",
      ai_studio_initial_sample_mode: false,
      ai_studio_initial_sample_title: "",
      ai_studio_initial_sample_template_cd: "",
      ai_studio_initial_sample_ai_image_template_seq: "",
      ai_studio_initial_sample_reference_image_url: "",
      ai_studio_initial_sample_reference_image_use_yn: "N",
      ai_studio_initial_sample_scene_description: "",
      ai_studio_initial_sample_result_example_url: "",
      ai_studio_initial_image_url: "",
      ai_studio_initial_source_image_url: sourceImageUrl,
      ai_studio_initial_history_seq: aiStudioHistorySeq,
      ai_studio_initial_step_no: stepNo,
      ai_studio_initial_history_step_seq: aiStudioHistoryStepSeq,
      ai_studio_initial_result_seq: aiStudioHistoryStepResultSeq,
      ai_studio_initial_result_no: resultNo,
      ai_studio_initial_result_image_url: imageUrl,
      ai_studio_initial_ratio: imageRatio,
      ai_studio_initial_ratio_cd: ratioCd,
      ai_studio_initial_style_type_cd: styleTypeCd,
      ai_studio_initial_composition_type_cd: compositionTypeCd,
    });
  }

  handleInstagramRegister(item, e) {
    if (e) {
      e.stopPropagation();
    }

    const imageUrl = this.getImageUrl(item);

    if (!imageUrl) {
      window.alert("등록할 이미지가 없습니다.");
      return;
    }

    sessionStorage.setItem(AI_STUDIO_APPLY_IMAGE_STORAGE_KEY, JSON.stringify({
      opened_from: "AI_STUDIO_LIST",
      img_url: imageUrl,
      image_url: imageUrl,
      source_url: imageUrl,
      image_ratio: item.image_ratio || item.imageRatio || "1/1",
      seq: item.seq || item.img_seq || item.image_seq || "",
      ai_studio_history_seq: item.ai_studio_history_seq || "",
      selected_final_step_no: item.step_no || "",
      ai_studio_history_step_seq: item.ai_studio_history_step_seq || "",
      ai_studio_history_step_result_seq: item.ai_studio_history_step_result_seq || "",
      result_no: item.result_no || "",
    }));

    window.location.href = INSTAGRAM_CREATE_POST_URL + "?apply_ai_studio_image=Y";

    if (typeof this.props.onInstagramRegister === "function") {
      this.props.onInstagramRegister(item, e);
    }
  }

  moveToCreatePostWithImage(result) {
    const imageUrl = result.appliedImage || result.appliedValue || "";

    if (!imageUrl) {
      window.alert("등록할 이미지가 없습니다.");
      return;
    }

    const imageRatio = result.image_ratio || result.ratio || this.props.ratio || "1/1";

    sessionStorage.setItem(AI_STUDIO_APPLY_IMAGE_STORAGE_KEY, JSON.stringify({
      opened_from: "AI_STUDIO_LIST",
      img_url: imageUrl,
      image_url: imageUrl,
      source_url: imageUrl,
      image_ratio: imageRatio,
      ratio: imageRatio,
      ratio_cd: result.ratio_cd || "",
      ai_studio_history_seq: result.ai_studio_history_seq || "",
      selected_final_step_no: result.selectedFinalStepNo || "",
      ai_studio_history_step_seq: result.ai_studio_history_step_seq || "",
      ai_studio_history_step_result_seq: result.ai_studio_history_step_result_seq || "",
      result_no: result.result_no || "",
    }));

    window.location.href = INSTAGRAM_CREATE_POST_URL + "?apply_ai_studio_image=Y";
}

  moveToAutomationWithRule(result) {
    const promptList = result.appliedPrompts || [];

    if (!result.ai_studio_history_seq && (!Array.isArray(promptList) || promptList.length === 0)) {
      window.alert("자동화에 적용할 AI 스튜디오 규칙이 없습니다.");
      return;
    }

    sessionStorage.setItem(AI_STUDIO_APPLY_AUTOMATION_RULE_STORAGE_KEY, JSON.stringify({
      opened_from: "AI_STUDIO_LIST",
      ai_image_rule_applied_yn: "Y",
      ai_image_rule_prompt_list: promptList,
      ai_image_rule_thumb: result.appliedThumb || "",
      ai_studio_history_seq: result.ai_studio_history_seq || "",
      ai_studio_history_title: result.history_title || "",
      history_title: result.history_title || "",
      selected_final_step_no: result.selectedFinalStepNo || "",
      steps: (result.steps || []).map((step) => ({
        ...step,
        positive_prompt_text: undefined,
        negative_prompt_text: undefined,
      })),
      ai_studio_history_step_seq: result.ai_studio_history_step_seq || "",
      ai_studio_history_step_result_seq: result.ai_studio_history_step_result_seq || "",
      result_no: result.result_no || "",
    }));

    window.location.href = INSTAGRAM_CREATE_AI_IMAGE_AUTOMATION_URL + "?apply_ai_studio_rule=Y";
  }

  async handleDownloadImage(item, e) {
    if (e) {
      e.stopPropagation();
    }

    const imageUrl = this.getImageUrl(item);

    if (!imageUrl) {
      window.alert("다운로드할 이미지가 없습니다.");
      return;
    }

    try {
      const cacheBuster = imageUrl.includes('?') ? `&t=${new Date().getTime()}` : `?t=${new Date().getTime()}`;
      const fetchUrl = imageUrl + cacheBuster;
      const response = await fetch(fetchUrl);

      if (!response.ok) {
        throw new Error("이미지 다운로드 요청 실패");
      }

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = blobUrl;
      link.download = this.getDownloadFileName(item, imageUrl);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("AI 스튜디오 이미지 다운로드 실패:", error);
      this.downloadImageByLink(imageUrl, this.getDownloadFileName(item, imageUrl));
    }

    if (typeof this.props.onDownloadImage === "function") {
      this.props.onDownloadImage(item, e);
    }
  }

  getStudioHistoryStepSeq(item) {
    if (!item) {
      return "";
    }

    return item.ai_studio_history_step_seq
      || item.aiStudioHistoryStepSeq
      || "";
  }

  handleDeleteStudioImage(item, e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    const aiStudioHistoryStepSeq = this.getStudioHistoryStepSeq(item);

    if (!aiStudioHistoryStepSeq) {
      window.alert("삭제할 AI 스튜디오 이미지 정보를 찾을 수 없습니다.");
      return;
    }

    this.setState({
      deleteDialogOpen: true,
      deleteTarget: item,
      deleteProcessing: false,
    });
  }

  closeDeleteDialog() {
    if (this.state.deleteProcessing) {
      return;
    }

    this.setState({
      deleteDialogOpen: false,
      deleteTarget: null,
      deleteProcessing: false,
    });
  }

  async confirmDeleteStudioImage() {
    const { deleteTarget, deleteProcessing } = this.state;

    if (!deleteTarget || deleteProcessing) {
      return;
    }

    const aiStudioHistoryStepSeq = this.getStudioHistoryStepSeq(deleteTarget);

    if (!aiStudioHistoryStepSeq) {
      window.alert("삭제할 AI 스튜디오 이미지 정보를 찾을 수 없습니다.");
      return;
    }

    this.setState({
      deleteProcessing: true,
      save_dialog_show_state: true,
      save_dialog_content: "삭제 중 입니다...",
      save_dialog_button_list: [{ title: "확인", type: "1", display_yn: "N" }],
    });

    try {
      const response = await http.post(AI_STUDIO_GALLERY_STEP_HIDE_URL, {
        ai_studio_history_step_seq: aiStudioHistoryStepSeq,
      }, {
        headers: { "Content-Type": "application/json" },
      });
      const data = response && response.data ? response.data : {};

      if ((data.status && data.status !== "success") || (data.result && data.result !== "success")) {
        throw new Error(data.message || "AI 스튜디오 이미지 삭제에 실패했습니다.");
      }

      this.setState((prevState) => {
        const hiddenStudioImageStepSeqs = new Set(prevState.hiddenStudioImageStepSeqs || []);
        hiddenStudioImageStepSeqs.add(String(aiStudioHistoryStepSeq));

        return {
          studioImageList: (prevState.studioImageList || []).filter(
            (item) => String(this.getStudioHistoryStepSeq(item)) !== String(aiStudioHistoryStepSeq)
          ),
          totalCnt: Math.max((prevState.totalCnt || 0) - 1, 0),
          hiddenStudioImageStepSeqs: hiddenStudioImageStepSeqs,
          deleteDialogOpen: false,
          deleteTarget: null,
          deleteProcessing: false,
          save_dialog_show_state: true,
          save_dialog_content: "삭제 완료되었습니다.",
          save_dialog_button_list: [
            {
              title: "확인",
              type: "1",
              display_yn: "Y",
              event_method: () => this.setState({ save_dialog_show_state: false }),
            },
          ],
        };
      }, () => {
        this.handleRefreshStudioImageList();
        setTimeout(this.checkNeedLoadMore, 100);
      });
    } catch (error) {
      console.error("마이 스튜디오 갤러리 삭제 실패:", error);
      const message = error?.response?.data?.message || error?.message || "AI 스튜디오 이미지 삭제에 실패했습니다.";
      this.setState({
        deleteProcessing: false,
        save_dialog_show_state: false,
      }, () => window.alert(message));
    }
  }

  getDownloadFileName(item, imageUrl) {
    const seq = item.ai_studio_history_step_seq || item.seq || item.img_seq || item.image_seq || "";
    const urlWithoutQuery = String(imageUrl || "").split("?")[0];
    const extMatch = urlWithoutQuery.match(/\.([a-zA-Z0-9]+)$/);
    const ext = extMatch ? extMatch[1] : "jpg";

    return "robomd_ai_studio" + (seq ? "_" + seq : "") + "." + ext;
  }

  downloadImageByLink(imageUrl, fileName) {
    const link = document.createElement("a");

    link.href = imageUrl;
    link.download = fileName;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  async loadRecommendImages() {
    if (
      (Array.isArray(this.props.recommendImages) && this.props.recommendImages.length > 0) ||
      (Array.isArray(this.props.recommendedImages) && this.props.recommendedImages.length > 0)
    ) {
      return;
    }

    this.setState({ recommendImagesLoading: true });

    try {
      const params = window.location.hostname === "127.0.0.1"
        ? { is_test_use: "Y" }
        : {};
      const response = await http.get(AI_STUDIO_IMAGE_TEMPLATE_LIST_URL, { params });
      const data = response && response.data ? response.data : {};
      const list = Array.isArray(data.list) ? data.list : [];

      this.setState({
        recommendImages: list,
        recommendImagesLoading: false,
      });
    } catch (error) {
      console.error("AI 스튜디오 추천 템플릿 목록 호출 실패:", error);
      this.setState({
        recommendImages: [],
        recommendImagesLoading: false,
      });
    }
  }

  getRecommendImages() {
    if (Array.isArray(this.props.recommendImages) && this.props.recommendImages.length > 0) {
      return this.props.recommendImages;
    }
    if (Array.isArray(this.props.recommendedImages) && this.props.recommendedImages.length > 0) {
      return this.props.recommendedImages;
    }
    return this.state.recommendImages || [];
  }

  handleLoadMoreRecommend() {
    this.setState((prevState) => ({
      visibleRecommendCount: prevState.visibleRecommendCount + RECOMMEND_VISIBLE_COUNT_STEP,
    }));
  }

  getStudioImageList() {
    let studioImageList = this.state.studioImageList || [];

    if (Array.isArray(this.props.studioImageList) && this.props.studioImageList.length > 0) {
      studioImageList = this.props.studioImageList;
    } else if (Array.isArray(this.props.myStudioImageList) && this.props.myStudioImageList.length > 0) {
      studioImageList = this.props.myStudioImageList;
    }

    const hiddenStudioImageStepSeqs = this.state.hiddenStudioImageStepSeqs || new Set();

    return studioImageList.filter((item) => {
      const stepSeq = this.getStudioHistoryStepSeq(item);
      return !stepSeq || !hiddenStudioImageStepSeqs.has(String(stepSeq));
    });
  }

  getImageUrl(item) {
    return item.src
      || item.imageUrl
      || item.image_url
      || item.output_image_url
      || item.outputImageUrl
      || item.preview_image_url
      || item.generated_thumbnail_url
      || item.generated_image_url
      || item.source_url
      || item.thumbnail_url
      || item.file_url
      || "";
  }

  formatDateText(dateString) {
    if (!dateString) {
      return "";
    }

    const normalized = String(dateString).replace(
      /([+-]\d{2})(\d{2})$/,
      "$1:$2"
    );
    const date = new Date(normalized);

    if (isNaN(date.getTime())) {
      return String(dateString).substring(0, 10).replace(/-/g, ".");
    }

    const now = new Date();

    const todayStart = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    );

    const dateStart = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    );

    const diffMs = now.getTime() - date.getTime();
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(
      (todayStart.getTime() - dateStart.getTime()) / (1000 * 60 * 60 * 24)
    );

    const diffMinutes = Math.floor(diffMs / (1000 * 60));

    if (diffDays === 0) {
      if (diffMinutes < 1) {
        return "방금 전";
      }

      return diffHours >= 1
        ? diffHours + "시간 전"
        : diffMinutes + "분 전";
    }

    if (diffDays === 1) {
      return "어제";
    }

    // if (diffDays > 1 && diffDays < 7) {
    //   return diffDays + "일전";
    // }

    return date.getFullYear()
      + "."
      + String(date.getMonth() + 1).padStart(2, "0")
      + "."
      + String(date.getDate()).padStart(2, "0");
  }  

  getBadgeText(item) {
    return item.badgeText
      // || item.reg_date_text
      // || item.createdText
      // || item.created_text
      // || item.displayDate
      // || item.dateText
      || this.formatDateText(item.reg_date)
      // || item.title
      || "";
  }

  renderPlusIcon(size) {
    return (
      <img
        src="https://robomd.io/static/media/default_plus.466aee97.svg"
        className="plus-icon"
        style={{ width: size || 16 }}
        alt="+"
      />
    );
  }

  renderRecommendImageCard(item, index) {
    const imageUrl = this.getImageUrl(item);

    return (
      <div
        className="image-card"
        key={item.seq || item.id || imageUrl || index}
        role="button"
        tabIndex={0}
        onClick={(e) => this.handleUseRecommendImage(item, e)}
      >
        <div className={"card-badge mint-bg" + (item.badgeClassName ? " " + item.badgeClassName : "")}>
          {item.title || item.badgeText || "-"}
        </div>
        <img className="main-img" src={imageUrl} alt={item.alt || item.title || "추천 AI 이미지"} />
        <div className="hover-overlay">
          <button className="btn-overlay-outline" type="button" onClick={(e) => this.handleUseRecommendImage(item, e)}>
            이 스타일 사용
          </button>
        </div>
      </div>
    );
  }

  renderStudioImageCard(item, index) {
    const imageUrl = this.getImageUrl(item);
    const badgeText = this.getBadgeText(item);

    if (imageUrl == "undefined") {
      return null;
    }

    return (
      <div
        className="image-card"
        key={item.ai_studio_history_step_seq || item.seq || item.id || imageUrl || index}
        role="button"
        tabIndex={0}
        onClick={(e) => this.handleOpenStudioHistoryStep(item, e)}
      >
        {badgeText ? (
          <div className={"card-badge" + (item.badgeClassName ? " " + item.badgeClassName : "")}>
            {badgeText}
          </div>
        ) : null}
        <button
          className="card-delete-button"
          type="button"
          title="마이 스튜디오 갤러리에서 삭제"
          aria-label="마이 스튜디오 갤러리에서 삭제"
          onClick={(e) => this.handleDeleteStudioImage(item, e)}
        >
          <i className="fa fa-solid fa-trash-can"></i>
        </button>
        <img className="main-img" src={imageUrl} alt={item.alt || item.title || item.history_title || "마이 스튜디오 이미지"} />
        <div className="hover-overlay">
          <button className="btn-overlay btn-overlay-navy" type="button" onClick={(e) => this.handleOpenStudioHistoryStep(item, e)}>
            <i className="fa fa-solid fa-arrow-up-right-from-square"></i> 작업 열기
          </button>
          <button className="btn-overlay btn-overlay-mint" type="button" onClick={(e) => this.handleInstagramRegister(item, e)}>
            <i className="fa fa-brands fa-instagram"></i> 인스타 등록
          </button>
          <button className="btn-overlay btn-overlay-outline" type="button" onClick={(e) => this.handleDownloadImage(item, e)}>
            <i className="fa fa-solid fa-download"></i> 다운로드
          </button>
        </div>
      </div>
    );
  }

  renderEmptyState() {
    return (
      <div className="empty-state-wrapper">
        <img
          src="https://robomd.io/static/media/robo_img_icon.abed362a.svg"
          alt="빈 갤러리 아이콘"
          className="empty-state-icon"
        />
        <h4 className="empty-state-title">아직 생성된 AI 이미지가 없습니다.</h4>
        <p className="empty-state-desc">상단의 버튼을 눌러 우리 브랜드에 꼭 맞는 첫 번째 이미지를 만들어보세요.</p>
        <button className="common_button hover_mint empty-create-button" type="button" onClick={this.handleCreateImage}>
          {this.renderPlusIcon(14)} 새 이미지 만들기
        </button>
      </div>
    );
  }

  renderLoadingState() {
    return (
      <div className="empty-state-wrapper loading-state-wrapper">
        <img
          src="https://robomd.io/static/media/robo_img_icon.abed362a.svg"
          alt="AI 이미지 목록 로딩 아이콘"
          className="empty-state-icon"
        />
        <h4 className="empty-state-title">AI 이미지 목록을 불러오는 중입니다.</h4>
        <p className="empty-state-desc">잠시만 기다려주세요.</p>
      </div>
    );
  }

  renderLoadMoreState() {
    return (
      <div className="load-more-state">
        <span className="load-more-spinner"></span>
        <span>AI 이미지를 더 불러오는 중입니다.</span>
      </div>
    );
  }

  renderAiStudioPopup() {
    if (!this.state.show_robo_img_popup) {
      return null;
    }

    return (
      <AiImageStudioWorkflowClass
        view_mode="popup"
        ai_response_type="IMAGE"
        initial_prompt={this.state.ai_studio_initial_prompt || ""}
        initial_sample_prompt={this.state.ai_studio_initial_sample_prompt || ""}
        initial_sample_prompt_placeholder={this.state.ai_studio_initial_sample_prompt_placeholder || ""}
        initial_sample_mode={this.state.ai_studio_initial_sample_mode === true}
        initial_sample_title={this.state.ai_studio_initial_sample_title || ""}
        initial_sample_template_cd={this.state.ai_studio_initial_sample_template_cd || ""}
        initial_sample_ai_image_template_seq={this.state.ai_studio_initial_sample_ai_image_template_seq || ""}
        initial_sample_reference_image_url={this.state.ai_studio_initial_sample_reference_image_url || ""}
        initial_sample_reference_image_use_yn={this.state.ai_studio_initial_sample_reference_image_use_yn || "N"}
        initial_sample_scene_description={this.state.ai_studio_initial_sample_scene_description || ""}
        initial_sample_result_example_url={this.state.ai_studio_initial_sample_result_example_url || ""}
        initial_image_url={this.state.ai_studio_initial_image_url || ""}
        initial_source_image_url={this.state.ai_studio_initial_source_image_url || ""}
        onClose={() => {
          this.setState({
            show_robo_img_popup: false,
            ai_studio_initial_prompt: "",
            ai_studio_initial_sample_prompt: "",
            ai_studio_initial_sample_mode: false,
            ai_studio_initial_sample_title: "",
            ai_studio_initial_sample_template_cd: "",
            ai_studio_initial_sample_ai_image_template_seq: "",
            ai_studio_initial_sample_reference_image_url: "",
            ai_studio_initial_sample_reference_image_use_yn: "N",
            ai_studio_initial_sample_scene_description: "",
            ai_studio_initial_sample_result_example_url: "",
            ai_studio_initial_image_url: "",
            ai_studio_initial_source_image_url: "",
            ai_studio_initial_history_seq: "",
            ai_studio_initial_step_no: "",
            ai_studio_initial_history_step_seq: "",
            ai_studio_initial_result_seq: "",
            ai_studio_initial_result_no: "",
            ai_studio_initial_result_image_url: "",
            ai_studio_initial_ratio: "",
            ai_studio_initial_ratio_cd: "",
            ai_studio_initial_style_type_cd: "",
            ai_studio_initial_composition_type_cd: "",
          }, this.handleRefreshStudioImageList);
        }}
        onApplyRule={(result) => {
          this.setState({
            show_robo_img_popup: false,
            ai_studio_initial_prompt: "",
            ai_studio_initial_sample_prompt: "",
            ai_studio_initial_sample_mode: false,
            ai_studio_initial_sample_title: "",
            ai_studio_initial_sample_template_cd: "",
            ai_studio_initial_sample_ai_image_template_seq: "",
            ai_studio_initial_sample_reference_image_url: "",
            ai_studio_initial_sample_reference_image_use_yn: "N",
            ai_studio_initial_sample_scene_description: "",
            ai_studio_initial_sample_result_example_url: "",
            ai_studio_initial_image_url: "",
            ai_studio_initial_source_image_url: "",
            ai_studio_initial_history_seq: "",
            ai_studio_initial_step_no: "",
            ai_studio_initial_history_step_seq: "",
            ai_studio_initial_result_seq: "",
            ai_studio_initial_result_no: "",
            ai_studio_initial_result_image_url: "",
            ai_studio_initial_ratio: "",
            ai_studio_initial_ratio_cd: "",
            ai_studio_initial_style_type_cd: "",
            ai_studio_initial_composition_type_cd: "",
          }, () => {
            if (this.getAiStudioHistoryUrl()) {
              this.loadStudioHistory(true);
            }

            if (result.ai_response_type === "IMAGE") {
              if (typeof this.props.onApplyImage === "function") {
                this.props.onApplyImage(result.appliedImage || result.appliedValue || "", result);
              } else {
                this.moveToCreatePostWithImage(result);
              }
            } else {
              if (typeof this.props.onApplyAutomationRule === "function") {
                this.props.onApplyAutomationRule(result);
              } else {
                this.moveToAutomationWithRule(result);
              }
            }
          });
        }}
        ratio={this.props.ratio || "1/1"}
        service_type={this.props.service_type || "01014"}
        opened_from="AI_STUDIO_LIST"
        onRefreshStudioImageList={this.handleRefreshStudioImageList}
        initial_history_seq={this.state.ai_studio_initial_history_seq || ""}
        initial_step_no={this.state.ai_studio_initial_step_no || ""}
        initial_history_step_seq={this.state.ai_studio_initial_history_step_seq || ""}
        initial_result_seq={this.state.ai_studio_initial_result_seq || ""}
        initial_result_no={this.state.ai_studio_initial_result_no || ""}
        initial_result_image_url={this.state.ai_studio_initial_result_image_url || ""}
        initial_ratio={this.state.ai_studio_initial_ratio || ""}
        initial_ratio_cd={this.state.ai_studio_initial_ratio_cd || ""}
        initial_style_type_cd={this.state.ai_studio_initial_style_type_cd || ""}
        initial_composition_type_cd={this.state.ai_studio_initial_composition_type_cd || ""}
      />
    );
  }

  toggleUnifiedSection(section) {
    const key = section === "recommend" ? "recommendExpanded" : "galleryExpanded";
    const willExpand = !this.state[key];
    this.setState({ [key]: willExpand }, () => {
      if (willExpand && section === "gallery") {
        if (typeof this.checkNeedLoadMore === "function") {
          this.checkNeedLoadMore();
        }
      } else if (!willExpand) {
        const target = section === "recommend" ? this.recommendSectionEl : this.gallerySectionEl;
        if (target && typeof target.scrollIntoView === "function") {
          target.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }
    });
  }

  renderStyle() {
    return `
      ${this.props.embedded ? "" : `#page-wrapper {
        padding: 72px 0 0 220px;
        max-width: 100%;
      }`}

      .instagram-ai-studio-list {
        --primary-mint: #00e2e6;
        --primary-dark: #00bfc2;
        --navy-dark: #0A1A2F;
        --bg-body: #f4f7f9;
        --bg-canvas: #ffffff;
        --text-primary: #111827;
        --text-secondary: #4b5563;
        --text-muted: #9ca3af;
        --border-color: #e5e7eb;
        --border-light: #f3f4f6;
        background-color: var(--bg-body);
        color: var(--text-primary);
        min-height: 100vh;
        width: 100%;
        overflow-x: hidden;
        font-family: 'Noto Sans KR', sans-serif;
        letter-spacing: -0.3px;
      }

      .instagram-ai-studio-list *,
      .instagram-ai-studio-list *::before,
      .instagram-ai-studio-list *::after {
        box-sizing: border-box;
      }

      .instagram-ai-studio-list button {
        font-family: inherit;
      }

      .instagram-ai-studio-list .fa {
        font-family: "Font Awesome 6 Free" !important;
        font-style: normal;
        font-weight: 900;
      }

      .instagram-ai-studio-list .fa-brands {
        font-family: "Font Awesome 6 Brands" !important;
        font-weight: 400;
      }

      .instagram-ai-studio-list .main-content {
        display: flex;
        flex-direction: column;
        min-width: 0;
        width: 100%;
      }

      .instagram-ai-studio-list .top-header {
        height: 60px;
        background-color: var(--bg-canvas);
        border-bottom: 1px solid var(--border-color);
        display: flex;
        align-items: center;
        padding: 0 32px;
        font-size: 14px;
        font-weight: 600;
        color: var(--text-primary);
      }

      .instagram-ai-studio-list .top-header span {
        color: var(--text-muted);
        font-weight: 400;
        margin-right: 8px;
      }

      .instagram-ai-studio-list .content-inner {
        padding: 48px 40px;
        max-width: 1600px;
        width: 100%;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        gap: 48px;
      }

      .instagram-ai-studio-list .center-hero {
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
        margin-bottom: 16px;
      }

      .instagram-ai-studio-list .center-hero h2 {
        font-size: 28px;
        font-weight: 700;
        color: var(--navy-dark);
        margin: 0;
      }

      .instagram-ai-studio-list .center-hero p {
        font-size: 15px;
        color: var(--text-secondary);
        margin: 0 0 16px 0;
      }

      .instagram-ai-studio-list .common_button.hover_mint {
        border-radius: 8px !important;
        font-weight: 700 !important;
        box-shadow: 0 4px 12px rgba(0, 226, 230, 0.2);
        transition: all 0.2s !important;
      }

      .instagram-ai-studio-list .common_button.hover_mint:hover {
        background: #00D3E0 !important;
        transform: translateY(-2px) !important;
      }

      .instagram-ai-studio-list .common_button.hover_mint::after {
        width: 0px !important;
        height: 0px !important;
      }

      .instagram-ai-studio-list .common_button.hover_mint,
      .instagram-ai-studio-list .btn-mint {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        border: none;
        background: var(--primary-mint);
        color: var(--navy-dark);
        cursor: pointer;
        padding: 14px 32px;
        font-size: 15px;
        line-height: 1;
        text-decoration: none;
      }

      .instagram-ai-studio-list .plus-icon {
        filter: brightness(0);
        flex-shrink: 0;
      }

      .instagram-ai-studio-list .section-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        margin-bottom: 16px;
        padding-bottom: 12px;
        border-bottom: 2px solid var(--border-color);
      }

      .instagram-ai-studio-list .gallery-section .section-header.empty-header {
        margin-bottom: 0;
      }

      .instagram-ai-studio-list .section-title h3 {
        font-size: 18px;
        font-weight: 700;
        color: var(--navy-dark);
        margin: 0;
      }

      .instagram-ai-studio-list .section-count {
        font-size: 14px;
        font-weight: 600;
        color: var(--text-secondary);
      }

      .instagram-ai-studio-list .section-count span {
        color: var(--primary-dark);
      }

      .instagram-ai-studio-list .unified-image-grid {
        display: grid;
        grid-template-columns: repeat(6, 1fr);
        gap: 20px;
        width: 100%;
      }

      .instagram-ai-studio-list .recommend-load-more-wrap {
        margin-top: 24px;
        display: flex;
        justify-content: center;
      }

      .instagram-ai-studio-list .recommend-load-more-button {
        padding: 4px 8px;
        border: 0;
        background: transparent;
        color: var(--text-secondary);
        font-size: 14px;
        font-weight: 600;
        line-height: 1.4;
        cursor: pointer;
        transition: color 0.2s ease;
        display: inline-flex;
        align-items: center;
        gap: 5px;
      }

      .instagram-ai-studio-list .recommend-load-more-button:hover {
        color: var(--primary-mint);
      }

      .instagram-ai-studio-list .image-card {
        position: relative;
        border-radius: 10px;
        overflow: hidden;
        background: var(--bg-canvas);
        border: 1px solid var(--border-color);
        box-shadow: 0 2px 8px rgba(10, 26, 47, 0.03);
        aspect-ratio: 1 / 1;
        cursor: pointer;
        transition: transform 0.3s ease, box-shadow 0.3s ease;
      }

      .instagram-ai-studio-list .image-card img.main-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.4s ease;
      }

      .instagram-ai-studio-list .card-badge {
        position: absolute;
        top: 10px;
        left: 10px;
        background: rgba(255, 255, 255, 0.95);
        color: var(--navy-dark);
        font-size: 11px;
        font-weight: 700;
        padding: 4px 10px;
        border-radius: 20px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
        z-index: 10;
      }

      .instagram-ai-studio-list .card-badge.mint-bg {
        background: rgba(10, 26, 47, 0.9);
        color: var(--primary-mint);
      }

      .instagram-ai-studio-list .card-delete-button {
        position: absolute;
        top: 10px;
        right: 10px;
        width: 30px;
        height: 30px;
        border: none;
        border-radius: 999px;
        color: #ffffff;
        z-index: 20;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        opacity: 0;
        transform: translateY(-3px);
        transition: all 0.2s ease;
      }

      .instagram-ai-studio-list .image-card:hover .card-delete-button {
        opacity: 1;
        transform: translateY(0);
      }

      .instagram-ai-studio-list .card-delete-button:hover {
        border-radius: 999px;
        background: rgba(255, 255, 255, 0.1);
      }

      .instagram-ai-studio-list .hover-overlay {
        position: absolute;
        inset: 0;
        background: rgba(10, 26, 47, 0.75);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 8px;
        opacity: 0;
        transition: all 0.2s ease;
        z-index: 10;
        padding: 12px;
      }

      .instagram-ai-studio-list .image-card:hover {
        transform: translateY(-4px);
        box-shadow: 0 8px 16px rgba(10, 26, 47, 0.08);
        border-color: var(--primary-dark);
      }

      .instagram-ai-studio-list .image-card:hover img.main-img {
        transform: scale(1.05);
      }

      .instagram-ai-studio-list .image-card:hover .hover-overlay {
        opacity: 1;
      }

      .instagram-ai-studio-list .btn-overlay,
      .instagram-ai-studio-list .btn-overlay-mint,
      .instagram-ai-studio-list .btn-overlay-outline {
        width: 100%;
        max-width: 140px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        padding: 7px 12px;
        border-radius: 6px;
        font-size: 12px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s;
        border: none;
      }

      .instagram-ai-studio-list .btn-overlay i,
      .instagram-ai-studio-list .btn-overlay-mint i,
      .instagram-ai-studio-list .btn-overlay-outline i {
        font-size: 13px;
      }

      .instagram-ai-studio-list .btn-overlay-mint {
        background: var(--primary-mint);
        color: var(--navy-dark);
        border: none;
        font-weight: 700;
      }

      .instagram-ai-studio-list .btn-overlay-mint:hover {
        background: var(--primary-dark);
      }

      .instagram-ai-studio-list .btn-overlay-navy {
        background: #1f2937;
        color: #ffffff;
      }

      .instagram-ai-studio-list .btn-overlay-navy:hover {
        background: #374151;
      }

      .instagram-ai-studio-list .btn-overlay-outline {
        background: transparent;
        color: #ffffff;
        border: 1px solid rgba(255, 255, 255, 0.6);
      }

      .instagram-ai-studio-list .btn-overlay-outline:hover {
        background: rgba(255, 255, 255, 0.15);
        border-color: #ffffff;
      }

      .instagram-ai-studio-list .empty-state-wrapper {
        width: 100%;
        margin-top: 16px;
        background: var(--bg-canvas);
        border: 1px dashed var(--border-color);
        border-radius: 12px;
        padding: 80px 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
      }

      .instagram-ai-studio-list .empty-state-icon {
        width: 56px;
        height: 56px;
        opacity: 0.4;
        margin-bottom: 20px;
      }

      .instagram-ai-studio-list .empty-state-title {
        font-size: 18px;
        font-weight: 700;
        color: var(--navy-dark);
        margin: 0 0 8px 0;
      }

      .instagram-ai-studio-list .empty-state-desc {
        font-size: 14px;
        color: var(--text-secondary);
        margin: 0 0 24px 0;
      }

      .instagram-ai-studio-list .empty-create-button {
        padding: 12px 24px;
        font-size: 14px;
      }

      .instagram-ai-studio-list .loading-state-wrapper .empty-state-icon {
        animation: instagramAiStudioLoading 1.2s ease-in-out infinite;
      }

      .instagram-ai-studio-list .load-more-state {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 22px 0 4px;
        font-size: 13px;
        font-weight: 600;
        color: var(--text-secondary);
      }

      .instagram-ai-studio-list .load-more-spinner {
        width: 16px;
        height: 16px;
        border: 2px solid rgba(0, 226, 230, 0.25);
        border-top-color: var(--primary-dark);
        border-radius: 50%;
        animation: instagramAiStudioSpin 0.8s linear infinite;
      }

      @keyframes instagramAiStudioLoading {
        0% {
          transform: translateY(0);
          opacity: 0.3;
        }
        50% {
          transform: translateY(-4px);
          opacity: 0.55;
        }
        100% {
          transform: translateY(0);
          opacity: 0.3;
        }
      }

      @keyframes instagramAiStudioSpin {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }

      @media screen and (max-width: 1280px) {
        .instagram-ai-studio-list .unified-image-grid {
          grid-template-columns: repeat(4, 1fr);
          gap: 16px;
        }
      }

      @media screen and (max-width: 1024px) {
        .instagram-ai-studio-list .top-header {
          display: none;
        }

        .instagram-ai-studio-list .content-inner {
          padding: 32px 24px;
          gap: 32px;
        }

        .instagram-ai-studio-list .unified-image-grid {
          grid-template-columns: repeat(3, 1fr);
        }

        .instagram-ai-studio-list .empty-state-wrapper {
          padding: 60px 20px;
        }
      }

      @media screen and (max-width: 768px) {
        .instagram-ai-studio-list .center-hero h2 {
          font-size: 22px;
        }

        .instagram-ai-studio-list .center-hero p {
          font-size: 13px;
          padding: 0 16px;
          word-break: keep-all;
        }

        .instagram-ai-studio-list .content-inner {
          padding: 24px 16px;
          gap: 24px;
        }

        .instagram-ai-studio-list .unified-image-grid {
          grid-template-columns: repeat(2, 1fr);
          gap: 12px;
        }

        .instagram-ai-studio-list .card-badge {
          padding: 3px 8px;
          font-size: 10px;
        }

        .instagram-ai-studio-list .btn-overlay,
        .instagram-ai-studio-list .btn-overlay-mint,
        .instagram-ai-studio-list .btn-overlay-outline {
          font-size: 11px;
          padding: 6px 8px;
          max-width: 100%;
        }
      }
    `;
  }

  render() {
    const recommendImages = this.getRecommendImages();
    const collapsedCount = this.props.collapsedCount || RECOMMEND_VISIBLE_COUNT_STEP;
    const visibleRecommendImages = recommendImages.slice(0, this.props.embedded ? (this.state.recommendExpanded ? recommendImages.length : collapsedCount) : this.state.visibleRecommendCount);
    const hasMoreRecommendImages = visibleRecommendImages.length < recommendImages.length;
    const studioImageList = this.getStudioImageList();
    const hasStudioImageList = studioImageList.length > 0;
    const isStudioImageListLoading = this.state.studioImageListLoading && !hasStudioImageList;
    const isStudioImageListMoreLoading = this.state.studioImageListLoading && hasStudioImageList;
    const totalStudioImageCount = this.state.totalCnt || studioImageList.length;
    const displayedGalleryList = (this.props.embedded && !this.state.galleryExpanded) ? studioImageList.slice(0, collapsedCount) : studioImageList;

    const content = (
      <div className="instagram-product-automation-list instagram-ai-studio-list">
          <style>{this.renderStyle()}</style>

          <main className="main-content">
            {!this.props.embedded && (
              <header className="top-header">
                <span>AI도구 &gt;</span> AI스튜디오
              </header>
            )}

            <div className="content-inner">
              {!this.props.embedded && (
                <section className="center-hero">
                  <h2>AI 스튜디오</h2>
                  <p>로보MD가 제공하는 다양한 스타일을 확인하고 브랜드에 맞는 이미지를 생성해보세요.</p>
                  <button className="common_button hover_mint" type="button" onClick={this.handleCreateImage}>
                    {this.renderPlusIcon(16)} 새 이미지 만들기
                  </button>
                </section>
              )}

              <section className="recommend-section" ref={(el) => { this.recommendSectionEl = el; }}>
                {this.props.embedded ? (
                  <StudioSectionHeader title="AI 이미지 스타일 갤러리" totalCount={recommendImages.length}
                    buttonText="모든 템플릿 보기" expanded={this.state.recommendExpanded} canToggle={recommendImages.length > collapsedCount}
                    onToggle={() => this.toggleUnifiedSection("recommend")} />
                ) : (
                  <div className="section-header"><div className="section-title"><h3>로보MD 용도별 추천 AI 이미지</h3></div></div>
                )}

                <div className="unified-image-grid">
                  {visibleRecommendImages.map((item, index) => this.renderRecommendImageCard(item, index))}
                </div>
                {this.props.embedded ? (
                  <StudioFoldControl expanded={this.state.recommendExpanded && recommendImages.length > collapsedCount} label="접기" onToggle={() => this.toggleUnifiedSection("recommend")} />
                ) : hasMoreRecommendImages ? (
                  <div className="recommend-load-more-wrap">
                    <button className="recommend-load-more-button" type="button" onClick={this.handleLoadMoreRecommend}>
                      <span>더보기</span>
                      <i className="fa fa-angle-down fa-solid" aria-hidden="true" />
                    </button>
                  </div>
                ) : null}
              </section>

              <section className="gallery-section" ref={(el) => { this.gallerySectionEl = el; }}>
                {this.props.embedded ? (
                  <StudioSectionHeader title="마이 갤러리" totalCount={totalStudioImageCount}
                    buttonText="모든 작업물 보기" expanded={this.state.galleryExpanded}
                    canToggle={studioImageList.length > collapsedCount || totalStudioImageCount > collapsedCount}
                    onToggle={() => this.toggleUnifiedSection("gallery")} />
                ) : (
                  <div className={"section-header" + (!hasStudioImageList ? " empty-header" : "")}>
                    <div className="section-title"><h3>마이 스튜디오 갤러리</h3></div>
                    {hasStudioImageList ? <div className="section-count">총 <span>{totalStudioImageCount}</span>개의 이미지</div> : null}
                  </div>
                )}

                {isStudioImageListLoading ? (
                  this.renderLoadingState()
                ) : hasStudioImageList ? (
                  <>
                    <div className="unified-image-grid">
                      {displayedGalleryList.map((item, index) => this.renderStudioImageCard(item, index))}
                    </div>
                    {isStudioImageListMoreLoading && (!this.props.embedded || this.state.galleryExpanded) ? this.renderLoadMoreState() : null}
                    {this.props.embedded ? <StudioFoldControl expanded={this.state.galleryExpanded} label="작업물 접기" onToggle={() => this.toggleUnifiedSection("gallery")} /> : null}
                  </>
                ) : (
                  this.renderEmptyState()
                )}
              </section>
            </div>
          </main>
          {this.renderAiStudioPopup()}
          {this.state.deleteDialogOpen && this.state.deleteTarget && (
            <TitleContentDialogV2
              title="이 이미지를 삭제하시겠습니까?"
              content="삭제하면 마이 스튜디오 갤러리에서만 사라집니다.<br/>AI 스튜디오 작업 이력과 생성된 이미지 데이터는 삭제되지 않습니다."
              popup_close={this.closeDeleteDialog}
              button_list={[
                {
                  title: this.state.deleteProcessing ? "삭제 중..." : "삭제",
                  event_method: this.confirmDeleteStudioImage,
                },
                {
                  title: "취소",
                  event_method: this.closeDeleteDialog,
                },
              ]}
            />
          )}
          {this.state.save_dialog_show_state && (
            <SaveDialogV2
              content={this.state.save_dialog_content}
              button_list={this.state.save_dialog_button_list}
            />
          )}
      </div>
    );

    // 기존 관리자 레이아웃은 독립 페이지에서만 사용합니다.
    // 통합 페이지(embedded=true)에는 page-wrapper DOM 자체를 생성하지 않습니다.
    return this.props.embedded ? content : (
      <div id="page-wrapper">
        {content}
      </div>
    );
  }
}

export default InstagramAiStudioList;